import React from 'react';
import PropTypes from 'prop-types';
import useLink from 'Hooks/useLink';
import DataContainer from 'Components/UI/DataContainer';
import {
  ProposalProjectionSectionSkeleton,
} from 'Organisms/ProposalProjectionSection/ProposalProjectionSectionSkeleton';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { ProposalProjectionSection } from './ProposalProjectionSection';

const useStyles = buildUseStyles('ProposalInflowsSectionContainer', () => ({
  root: {
    width: '100%',
  },
}));

const ProposalProjectionSectionContainer = ({ relationship }) => {
  const {
    collection, loadingError, isInitializing,
  } = useLink(relationship.link('related'));
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <DataContainer
      className={classes.root}
      component={ProposalProjectionSection}
      componentProps={{
        resource: collection?.resources()?.head(),
      }}
      loading={isInitializing}
      loadingError={loadingError}
      skeleton={ProposalProjectionSectionSkeleton}
    />
  );
};

ProposalProjectionSectionContainer.propTypes = {
  relationship: PropTypes.object.isRequired,
};
ProposalProjectionSectionContainer.defaultProps = {};

export default ProposalProjectionSectionContainer;
